<div class="center-align-data">
  <div class="logo" cygovSvgIcon svgName="centraleyes-logo1"></div>
  <span class="lato-20-b-vw no-data">{{ message }}</span>
  <div class="clear-search lato-18-n-vw" *ngIf="showClear" (click)="clearSearch.emit()"
    role="button" tabindex="0" [attr.aria-label]="clearLabel"
    (keydown.enter)="clearSearch.emit(); $event.preventDefault()"
    (keydown.space)="clearSearch.emit(); $event.preventDefault()">{{ clearLabel }}</div>
</div>
